import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CategoryModal = ({ isOpen, onClose, onSave, category }) => {
  const [formData, setFormData] = useState({
    name: '',
    icon: 'Sparkles'
  });

  const [errors, setErrors] = useState({});

  const iconOptions = [
    { value: 'Sparkles', label: 'Sparkles' },
    { value: 'Scissors', label: 'Scissors' },
    { value: 'Palette', label: 'Palette' },
    { value: 'Heart', label: 'Heart' },
    { value: 'Star', label: 'Star' },
    { value: 'Crown', label: 'Crown' },
    { value: 'Gem', label: 'Gem' },
    { value: 'Flower', label: 'Flower' }
  ];

  useEffect(() => {
    if (category) {
      setFormData({
        name: category?.name || '',
        icon: category?.icon || 'Sparkles'
      });
    } else {
      setFormData({
        name: '',
        icon: 'Sparkles'
      });
    }
    setErrors({});
  }, [category, isOpen]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.name?.trim()) {
      newErrors.name = 'Category name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (validateForm()) {
      const categoryData = {
        ...formData,
        id: category?.id || Date.now()
      };
      
      onSave(categoryData);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground">
            {category ? 'Edit Category' : 'Add New Category'}
          </h2>
          <Button
            variant="ghost"
            size="icon"
            iconName="X"
            iconSize={20}
            onClick={onClose}
          />
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4 md:space-y-5">
          <Input
            label="Category Name"
            type="text"
            placeholder="e.g., Manicure Services"
            value={formData?.name}
            onChange={(e) => handleChange('name', e?.target?.value)}
            error={errors?.name}
            required
          />

          <Select
            label="Icon"
            options={iconOptions}
            value={formData?.icon}
            onChange={(value) => handleChange('icon', value)}
            description="Choose an icon to represent this category"
          />

          <div className="p-4 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground font-caption mb-3">Preview:</p>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gradient-to-br from-primary to-secondary rounded-lg">
                <Icon name={formData?.icon} size={20} color="white" />
              </div>
              <span className="font-heading font-bold text-lg text-foreground">
                {formData?.name || 'Category Name'}
              </span>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={onClose}
              type="button"
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={handleSubmit}
              iconName="Save"
              iconPosition="left"
              iconSize={18}
            >
              {category ? 'Update Category' : 'Add Category'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;